export default __webpack_public_path__ + "static/media/publicationBg.740a8d7c.png";